module.exports = __webpack_public_path__ + "img/image-footer.73b8bb39.jpg";